export const API_ROOT = 'https://api.dragoncanoe.com';
//export const API_ROOT = 'http://127.0.0.1:5000';
export const HOST_NAME = 'https://www.dragoncanoe.com';
//export const HOST_NAME = 'http://127.0.0.1:3000';

export const MAX_FILE_SIZE = 1024 * 200;